<sl-page-header [header]="pageTitle">
  <div slot="actions" style="box-sizing: border-box">

    <sl-button-group class="mr-3">
      <sl-button
        [disabled]="assignmentForm.invalid || readonly || assignment.action==='Completed' || assignment.action==='Skipped'"
        type="primary" (click)="changeAction('Completed')" i18n>Mark Complete</sl-button>
      <sl-dropdown placement="bottom-end">
        <sl-button slot="trigger" type="primary" [disabled]="assignmentForm.invalid" caret></sl-button>
        <sl-menu>
          <sl-menu-item (click)="changeAction('InProgress')" [disabled]="assignment.action!=='None'" 
          i18n>Start now</sl-menu-item>
          <sl-menu-item (click)="changeAction('Skipped')" [disabled]="assignment.action!=='None'"
          i18n>Skip</sl-menu-item>
          <sl-divider></sl-divider>
          <sl-menu-item (click)="resetAction()" [disabled]="assignment.action==='None'" i18n>Reset status</sl-menu-item>
        </sl-menu>
      </sl-dropdown>
    </sl-button-group>
    <sl-button *ngIf="cancelable" class="mr-3" (click)="onCancelClick()" i18n>Cancel</sl-button>
    <sl-button [disabled]="assignmentForm.invalid || readonly" class="mr-3" (click)="onSaveClick()" i18n>Save
    </sl-button>
  </div>
</sl-page-header>
<sl-layout>
  <form [formGroup]="assignmentForm">
    <div *ngIf="isInitialized()" class=" mt-4 grid grid-cols-12 assignment-editor"
      [class.assignment-editor--files-shown]="filesShown">
      <!-- Customer selection -->
      <div class="grid gap-2 col-span-3">
        <sl-fieldset size="small">
          <sl-fieldrow>
            <sl-select *ngIf="editableContact" debounce="250" searchable clearable placeholder="Customer" i18n-placeholder
              (slSearch)="this.searchContact($any($event))" formControlName="contactId" [search]="assignment.contactName">
              <sl-menu-item *ngFor="let contact of searchedContacts" [value]="contact.id">{{contact.name}}</sl-menu-item>
            </sl-select>

            <ng-container *ngIf="!editableContact">
              <input type="hidden" formControlName="contactId">
              <sl-input [value]="assignment.contactName" disabled></sl-input>
            </ng-container>            
          </sl-fieldrow>

          <ng-container formGroupName="address">
            <sl-fieldrow>
              <sl-input width="3/4" placeholder="Street and number" i18n-placeholder class="col-span-3" size="small"
                formControlName="street"></sl-input>
              <sl-input width="1/4" placeholder="apt." i18n-placeholder size="small" formControlName="apartment">
              </sl-input>
            </sl-fieldrow>
            <sl-fieldrow>
              <sl-input width="1/4" placeholder="Postal code" i18n-placeholder class="col-span-2" size="small"
                formControlName="postalCode"></sl-input>
              <sl-input width="3/4" placeholder="City" i18n-placeholder class="col-span-3" size="small"
                formControlName="city"></sl-input>
            </sl-fieldrow>
          </ng-container>
        </sl-fieldset>

        <sl-checkbox [disabled]="readonly" class="mt-2 mb-1" [checked]="deliveryAddressEnabled" (checkedChange)="deliveryAddressEnabled = $any($event).detail" i18n>Deliver to another address</sl-checkbox>
        <sl-fieldset size="small" [ngClass]="{'mb-6': true,'delivery-address--disabled':!deliveryAddressEnabled}">
          <ng-container formGroupName="deliveryAddress">
            <sl-fieldrow>
              <sl-input width="3/4" placeholder="Street and number" i18n-placeholder class="col-span-3" size="small"
                formControlName="street"></sl-input>
              <sl-input width="1/4" placeholder="apt." i18n-placeholder size="small" formControlName="apartment">
              </sl-input>
            </sl-fieldrow>
            <sl-fieldrow>
              <sl-input width="1/4" placeholder="Postal code" i18n-placeholder class="col-span-2" size="small"
                formControlName="postalCode"></sl-input>
              <sl-input width="3/4" placeholder="City" i18n-placeholder class="col-span-3" size="small"
                formControlName="city"></sl-input>
            </sl-fieldrow>
          </ng-container>
        </sl-fieldset>

      </div>

      <div class="col-start-7 col-span-6">
        <!-- Time planning-->
        <div class="grid gap-2 grid-cols-4">
          <sl-label i18n size="small">Planned</sl-label>
          <div class="col-span-3">
            <sl-fieldset size="small" formGroupName="plan">
              <sl-fieldrow>
                <sl-input type="date" size="small" formControlName="indicativeDate"></sl-input>
              </sl-fieldrow>
              <sl-fieldrow>
                <sl-select width="1/2" size="small" [disabled]="readonly || planLocked" [value]="planType"
                  (valueChange)="planType = $any($event).detail">
                  <sl-menu-item value="" i18n>At any time of day</sl-menu-item>
                  <sl-menu-item value="Exact" i18n>At</sl-menu-item>
                  <sl-menu-item value="Between" i18n>Between</sl-menu-item>
                  <sl-menu-item value="Within" i18n>Within</sl-menu-item>
                </sl-select>

                <ng-container *ngIf="planType==='Between' || planType==='Exact'" formGroupName="serviceWindow">
                  <sl-input [width]="planType==='Between' ? '1/4' : '1/2'"
                    *ngIf="planType==='Between' || planType==='Exact'" type="time" placeholder="12:00" size="small"
                    formControlName="startTime"></sl-input>
                  <sl-input width="1/4" *ngIf="planType==='Between'" type="time" placeholder="15:00" size="small"
                    formControlName="endTime"></sl-input>
                </ng-container>

                <ng-container>
                  <sl-select width="1/2" *ngIf="planType==='Within'" size="small" formControlName="completionDuePeriod">
                    <sl-menu-item *ngFor="let item of [].constructor(30); let i = index" value="P{{i+1}}D">
                      {{getDaysDisplayText(i + 1)}}</sl-menu-item>
                  </sl-select>
                </ng-container>
              </sl-fieldrow>
            </sl-fieldset>
            <sl-checkbox [disabled]="readonly || planLocked" size="small" [checked]="flexibleDate"
              (checkedChange)="flexibleDate = $any($event).detail">
              <sl-label size="small" i18n>Flexible date</sl-label>
            </sl-checkbox>
          </div>
        </div>

        <!-- Employee selection -->
        <div *ngIf="accounts.length > 0" class="grid gap-2 grid-cols-4 mt-6" formGroupName="plan">
          <sl-label i18n size="small">Can execute</sl-label>
          <div class="grid gap-2 col-span-3">
            <sl-select size="small" multiple placeholder="Enhver medarbejder" formControlName="accountIds">
              <span slot="help-text"
                *ngIf="isWorkAdjustedWithLeave() && !readonly && (assignment.plan.accountIds?.length ?? 0) > 0" 
                i18n>Planned for other employees in case of absence</span>
              <sl-menu-item *ngFor="let account of accounts" [value]="account.id">{{account.name}}</sl-menu-item>
            </sl-select>
          </div>
        </div>

        <!-- Status selection -->
        <div class="grid gap-2 grid-cols-4 mt-6 status-selection">
          <sl-label i18n size="small">Status</sl-label>

          <div class="col-span-3 status-selection--description">
            <sl-badge [type]="assignmentForm.value.action === 'Completed' ? 'success' : 'info'">
              {{assignmentForm.value.action | assignmentAction}}
            </sl-badge>

            <ng-container *ngIf="assignment.id != null">
              <sl-label class="name" size="small">{{workerDisplayText}}</sl-label>
              <sl-label size="small">@</sl-label>
              <app-time-label [assignment]="assignmentForm.value"></app-time-label>
              <!--sl-label class="time" size="small">{{assignment.plan.executionTime | date:'short'}}</sl-label-->
              <sl-tooltip *ngIf="assignment.plan.affixment.state === 'Locked'" placement="bottom" i18n-content
                content="Locked to date and resource by end-user">
                <sl-icon name="lock-fill"></sl-icon>
              </sl-tooltip>
            </ng-container>

          </div>
        </div>
      </div>

      <div class="col-span-3 ml-2 mb-3">
        <sl-switch size="small" [checked]="pricesIncludesTax" (checkedChange)="pricesIncludesTax = $any($event).detail" i18n>Show amounts with Vat</sl-switch>
      </div>
      <sl-table class="col-span-12">
        <sl-column width="" i18n>Description</sl-column>
        <sl-column style="width:100px" align="right" i18n>Duration</sl-column>
        <sl-column style="width:200px" align="right" i18n>Amount</sl-column>
        <sl-column style="width:50px" align="right"></sl-column>
        <ng-container *ngFor="let taskForm of taskGroups; let i = index">
          <sl-row [formGroup]="taskForm">
            <sl-cell type="string">
              <sl-fieldset size="small">
                <sl-fieldrow>
                  <sl-input class="assignment-editor__task-description"
                    [class.assignment-editor__task-description--open]="hasMessages(taskForm.value)" size="small"
                    formControlName="description">
                    <sl-icon name="chevron-down" class="assignment-editor__task-description-icon" slot="suffix"
                      (click)="toggleTaskNote(taskForm)"></sl-icon>
                  </sl-input>
                </sl-fieldrow>
                <ng-container *ngIf="hasMessages(taskForm.value)">
                  <sl-fieldrow>
                    <sl-input width="1/2" i18n-placeholder formControlName="priorMessage"
                      placeholder="Pre work customer message..." size="small"></sl-input>
                    <sl-input width="1/2" i18n-placeholder formControlName="message"
                      placeholder="Post work customer message..." size="small"></sl-input>
                  </sl-fieldrow>
                  <sl-fieldrow>
                    <sl-textarea i18n-placeholder placeholder="Note for worker..." size="small" rows="1"
                      formControlName="note"></sl-textarea>
                  </sl-fieldrow>
                </ng-container>
              </sl-fieldset>

            </sl-cell>
            <sl-cell>
              <sl-input class="text-right" size="small" align="right" type="number" formControlName="duration">
                <span slot="suffix" i18n>minutes</span>
              </sl-input>
            </sl-cell>
            <sl-cell [editable]="!readonly" type="string" slMoneyCentControl
              [taxRate]="pricesIncludesTax ? taxRate : 0.0" trigger="input" formControlName="unitPrice"></sl-cell>
            <sl-cell>
              <sl-icon-button [disabled]="readonly" class="assignment-editor__task-delete-icon" name="x-circle"
                (click)="removeTask(i)"></sl-icon-button>
            </sl-cell>
          </sl-row>
        </ng-container>
      </sl-table>

      <div class="col-span-6 mt-1">
        <sl-button type="text" (click)="addTask()" size="small" [disabled]="readonly">
          <sl-icon name="plus-circle" slot="suffix"></sl-icon>
          <span i18n>Add line</span>
        </sl-button>

        <sl-button *ngIf="assignment.id != null" class="assignment-editor__file-toggler" type="text"
          (click)="toggleFiles()" size="small">
          <sl-icon class="assignment-editor__file-toggler-icon" name="chevron-down" slot="suffix"></sl-icon>
          <span i18n>Attached files</span><span *ngIf="files?.length ?? 0 > 0">({{files?.length}})</span>
        </sl-button>

        <div *ngIf="filesShown">
          <sl-upload class="mt-4" type="Button" (upload)="handleFileUpload($any($event))"
            description="Upload Image or PDF file" accept="image/*,.pdf" i18n-description></sl-upload>
          <div class="mt-2">
            <sl-spinner size="small" *ngIf="files == null"></sl-spinner>
            <ng-container *ngIf="files != null">
              <app-file-entry *ngFor="let file of files" [file]="file" (fileDelete)="onFileDelete($event)">
              </app-file-entry>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="total col-start-9 col-span-4 mt-4 ml-6 mr-2">
        <div class="grid grid-cols-2">
          <sl-label size="small" i18n>Subtotal</sl-label>
          <sl-label size="small" class="total-exvat">{{total | currency:currency}}</sl-label>

          <sl-label size="small" i18n>Vat</sl-label>
          <sl-label size="small" class="total-vat">{{totalTax | currency:currency}}</sl-label>

          <sl-label class="total-incvat-label" i18n>Total amount</sl-label>
          <sl-label class="total-incvat">{{total + totalTax | currency:currency}}</sl-label>
        </div>

        <div class="grid grid-cols-2 mt-2">
          <div class="total-invoicing-label" i18n>Invoicing</div>
          <div class="total-invoicing" [ngSwitch]="assignment.status">
            <sl-badge *ngSwitchCase="'None'" type="info" i18n>Not invoiced</sl-badge>
            <sl-badge *ngSwitchCase="'NotInvoiced'" type="info" i18n>Not invoiced</sl-badge>
            <sl-badge *ngSwitchCase="'AwaitingInvoicing'" type="warning" i18n>Awaiting invoicing</sl-badge>
            <sl-badge *ngSwitchCase="'AppendedToOrder'" type="success" i18n>Added to order</sl-badge>
            <sl-badge *ngSwitchCase="'Invoiced'" type="success" i18n>Invoiced</sl-badge>
            <sl-badge *ngSwitchCase="'Fulfilled'" type="success" i18n>Paid</sl-badge>
          </div>
        </div>
        <div class="mt-4 total__audit">
          <sl-popover *ngIf="assignment?.id != null" placement="top" (slShow)="auditRequested = true"
            style="--background: var(--sl-color-gray-100); --border-color: var(--sl-color-gray-300);">
            <sl-icon name="fingerprint" slot="trigger"></sl-icon>
            <ws-audit-preview *ngIf="auditRequested" [entity]="assignment"></ws-audit-preview>
          </sl-popover>
        </div>
      </div>
    </div>
  </form>
</sl-layout>